import { Button } from 'shared/ui/Button';
import { useModalsActions, SideModal, SideModalBody } from 'shared/ui/SideModal';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

interface ExitEditingModalProps {
  budget: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

export function BudgetExitModal({ onConfirm, onCancel, budget }: ExitEditingModalProps) {
  const { close } = useModalsActions();

  const onConfirmHandler = () => {
    if (onConfirm) {
      onConfirm();
    }
    close();
  };

  const onCancelHandler = () => {
    if (onCancel) {
      onCancel();
    }
    close();
  };

  return (
    <SideModal>
      <SideModalBody>
        <div className="flex h-full flex-col items-center justify-center">
          <h3 className=" text-center text-xl font-bold">Your weekly budget will be changed to {budget}</h3>
          <span className="mb-6 mt-2 w-[288px] text-center text-sm font-normal text-slate-700">
            Note that a budget increase will take effect immediately while a budget decrease will go into effect the
            following Monday.
          </span>
          <Button
            className="mb-2 w-63"
            onClick={onConfirmHandler}
            {...getDataAutoTestAttributes(['leave-modal-back-btn'])}
          >
            Confirm
          </Button>
          <Button
            className="w-63"
            onClick={onCancelHandler}
            variant="outline-second"
            {...getDataAutoTestAttributes(['leave-modal-close-btn'])}
          >
            Back to edit
          </Button>
        </div>
      </SideModalBody>
    </SideModal>
  );
}
